(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["minicart-right-sidebar"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function () {
    var productRecommendationsSection = document.querySelector('.product-CartUpsellSlider');
    var productIdInput = document.querySelector('.productIDCart');

    if (!productRecommendationsSection || !productIdInput || !productIdInput.value) {
      return;
    }

    var productId = productIdInput.value;

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=4&intent=related')
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Product recommendations request failed');
        }

        return response.json();
      })
      .then(function (recommendationData) {
        var products = Array.isArray(recommendationData.products) ? recommendationData.products : [];
        var htmlSe = '';

        if (products.length > 0) {
          products.forEach(function (RecommendedProduc, indexd) {
            if (!RecommendedProduc || !RecommendedProduc.url || !RecommendedProduc.featured_image || !Array.isArray(RecommendedProduc.variants) || !RecommendedProduc.variants[0]) {
              return;
            }

            var urlProdut = RecommendedProduc.url;
            var firstOption = Array.isArray(RecommendedProduc.options) ? RecommendedProduc.options[0] : null;
            var optionProductname = firstOption && firstOption.name ? firstOption.name : '';
            var optionProductValue = firstOption && Array.isArray(firstOption.values) ? firstOption.values[0] : '';
            var selectedVariation = RecommendedProduc.variants[0].id;
            var recommendedImageUrl = getCartImageSizedUrl(RecommendedProduc.featured_image, '160x160');

            if (indexd == 0) {
              htmlSe += '<div class="slide active">';
              htmlSe +=
                '<div class="imagepart"><a href="' +
                urlProdut +
                '"><img src="' +
                recommendedImageUrl +
                '" loading="lazy" decoding="async" width="80" height="80"></a></div>';
              htmlSe += '<div class="conetent-part">';
              htmlSe += '<a href="' + urlProdut + '">' + RecommendedProduc.title + '</a>';
              htmlSe += '<p>' + optionProductname + ':' + optionProductValue + '</p>';
              htmlSe += '<p class="price-r">$' + parseInt(RecommendedProduc.price) / 100 + '</p>';
              htmlSe +=
                '<a href="#" data-productid="' + selectedVariation + '" class="addtocartrecomend"> Add to bag  </a>';
              htmlSe += '</div>';
              htmlSe += '</div>';
            } else {
              htmlSe += '<div class="slide">';
              htmlSe +=
                '<div class="imagepart"><a href="' +
                urlProdut +
                '"><img src="' +
                recommendedImageUrl +
                '" loading="lazy" decoding="async" width="80" height="80"></a></div>';
              htmlSe += '<div class="conetent-part">';
              htmlSe += '<a href="' + urlProdut + '">' + RecommendedProduc.title + '</a>';
              htmlSe += '<p>' + optionProductname + ':' + optionProductValue + '</p>';
              htmlSe += '<p class="price-r">$' + parseInt(RecommendedProduc.price) / 100 + '</p>';
              htmlSe +=
                '<a href="#" data-productid="' + selectedVariation + '" class="addtocartrecomend"> Add to bag  </a>';
              htmlSe += '</div>';
              htmlSe += '</div>';
            }
          });

          $('.product-CartUpsellSlider .slider-container').html(htmlSe);
        } else {
          $('.product-CartUpsellSlider .slider-container').empty();
        }
      })
      .catch(function () {
        $('.product-CartUpsellSlider .slider-container').empty();
      });
  };

  window.addEventListener('load', function () {
    loadProductRecommendationsIntoSection();
  });

  let compatiblePlist = [];

  $(document).ready(function () {
    let slideCount = $('.slide').length;
    let currentIndex = 0;
    $('.slide').hide();
    $('.active').show();
    $('.prev').on('click', function () {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = slideCount - 1;
      }
      showSlide(currentIndex);
    });
    $('.next').on('click', function () {
      currentIndex++;
      if (currentIndex >= slideCount) {
        currentIndex = 0;
      }
      showSlide(currentIndex);
    });

    function showSlide(index) {
      $('.slide').hide().removeClass('active');
      $('.dot').removeClass('active-dot');
      $('.slide').eq(index).show().addClass('active');
      $('.dot').eq(index).addClass('active-dot');
    }
    showSlide(currentIndex);
  });

  $(document).ready(function () {
    $(document).on('click', '.btn.product-form__cart-submit', function (e) {
      setTimeout(getAllcarttPoduct, 1000);
    });
  });

  $(document).on('click', '#miniCartbutton', function (e) {
    e.preventDefault();
    var getTotal = $('#totalVlye').val();
    var maxwidth = (parseInt(getTotal) * 100) / 3000;

    $('.css-nxglc6').css('max-width', maxwidth + '%');

    $('.bodycor').show();

    loadProductRecommendationsIntoSection();
    getAllcarttPoduct();

    if (compatiblePlist.length > 0) {

      $('.warning-message-check').show();
    } else {
      $('.warning-message-check').hide();
    }

    $('#sidebarright').show();
  });

  $(document).on('click', '.css-1m15u4f, .bodycor', function (e) {
    e.preventDefault();
    loadProductRecommendationsIntoSection();
    $('#sidebarright').hide();
    $('.bodycor').hide();
  });

  $(document).on('click', '.css-15fa4x3, .removeproduct', function (e) {
    // get product id
    var productIDincrease = $(this).attr('data-id');

    // get click button type
    var typeOfAction = $(this).attr('data-type');

    // get Current Quantity number
    var quantityNumber = $('#updates_' + productIDincrease).val();

    // update Current Quantity Number
    if (typeOfAction == 1) {
      quantityNumber = parseInt(quantityNumber) + 1;
    } else if (typeOfAction == 3) {
      quantityNumber = 0;
    } else {
      quantityNumber = parseInt(quantityNumber) - 1;
    }
    if (quantityNumber >= 0) {
      $('#updates_' + productIDincrease).val(quantityNumber);
    }

    //   console.log('click new add number check' + productIDincrease);

    // console.log('click new add count test' + quantityNumber);

    var lineData = $(this).attr('data-key');

    let lineNymber = parseInt(lineData);

    let data = {
      line: lineNymber,
      quantity: quantityNumber,
    };

    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((response) => {
        //  console.log(response)

        if (typeOfAction == 3) {
          //  location.reload();
          $(this).parents('.cardrownow').remove();
          getAllcarttPoduct();
        } else {
          /* var sutotalamount = parseInt(response.items_subtotal_price);

          if( sutotalamount < 0001 ){
              var remainAmount = (settings.free_shipping_threshold - sutotalamount)/100;
             $('.css-1encgqi').html('You\'re only  $'+ remainAmount +' away from free shipping!');

             var maxwidth = (parseInt(sutotalamount) * 100)/settings.free_shipping_threshold;
             $('.css-nxglc6').css('max-width', maxwidth + '%');

          } else {
               $('.css-1encgqi').text('You\'re qualified for free shipping!');
              $('.css-nxglc6').css('max-width',  '100%');
          }

             if( quantityNumber == 0 ){
                location.reload();
             }





          var subAmout = parseInt(response.items_subtotal_price)/100;
          var currency = response.currency;
          $('.css-9jq8tb').text('$' + subAmout + ' ' + currency );  */

          getAllcarttPoduct();
        }

        checkTotalcompatible();
      });
  });

  $(document).on('click', '.css-1ctlmjg', function (e) {
    $('.discountwarp').show();
    $(this).hide();
    $('.css-1ctldown').show();
  });

  $(document).on('click', '.css-1ctldown', function (e) {
    $('.discountwarp').hide();
    $(this).hide();
    $('.css-1ctlmjg').show();
  });

  $(document).on('click', '.css-1m05wz', function (e) {
    $('.messagediscount').html('');
    var getDiscountCode = $('.css-1er0rpi').val();
    alart(1);
    if (getDiscountCode != '') {
      getDiscountCodeUrl($.trim(getDiscountCode));
    }
  });

  function getDiscountCodeUrl(discountCode) {
    fetch(window.Shopify.routes.root + 'admin/discount_codes/lookup.json?code=' + discountCode)
      .then((response) => {

        if (response.status === 200) {
          document.cookie = 'discount_code=' + discountCode;
          // $('.discountwarp').hide();
          //alert('Discount successfully applied. You can see on checkout page.');
          var dismessage = 'Discount code to be applied at checkout: <span>' + discountCode + '</span>';
          $('.messagediscount').html(dismessage);
          $('.messagediscount').removeClass('error');
        } else {
          //   alert('Your code is not valid');
          var dismessage = 'Your code is not valid';
          $('.messagediscount').html(dismessage);
          $('.messagediscount').addClass('error');
          //  $('.discountwarp').hide();
        }
      })
      .catch((err) => {
        alert('Your code is not valid');
        $('.discountwarp').hide();
      });
  }

  function FreeShippingMeter() {
    var getTotal = $('#totalVlye').val();
    if (getTotal == '') {
      getTotal = 0;
    }

    if (getTotal < freeShippingThreshold) {
      var remainAmount = (freeShippingThreshold - getTotal) / 100;
      $('.css-1encgqi').html("You're only  $" + remainAmount + ' away from free shipping!');

      var maxwidth = (parseInt(getTotal) * 100) / freeShippingThreshold;
      $('.css-nxglc6').css('max-width', maxwidth + '%');
    } else {
      $('.css-1encgqi').text("You're qualified for free shipping!");
      $('.css-nxglc6').css('max-width', '100%');
    }
    $('.FreeShippingMeter').show();
  }

  function testautoshowCart() {
  }

  $(document).on('click', '.addtocartrecomend', function (e) {
    var addProductID = $(this).attr('data-productid');

    //console.log(addProductID +'dhsfhgjdfhgk');

    //$.post( '/cart/add.js',  { quantity: 1, id: addProductID });

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { quantity: 1, id: addProductID },
      dataType: 'json',
      success: function () {
        $(this).parents('.slide').remove();
        $('.next').click();
        getAllcarttPoduct();
      },
      error: function () {},
    });
  });

  function getAllcarttPoduct() {
    return new Promise((resolve, reject) => {
      compatiblePlist = [];

      fetch('/cart.js', {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
        },
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Cart request failed');
          }

          return response.json();
        })
        .then(function (cart) {
          // Show loading state after getting cart data
          $('.bodycor').show();
          $('#sidebarright').show();

          var totalProduct = cart.item_count;
          updateHeaderCartCount(totalProduct);

          if (totalProduct > 0) {
            // Build cart items HTML
            let itemsAll = cart.items;
            var newcarttem = '';

            // Build cart items HTML
            itemsAll.forEach((item, ibm) => {
              var quantity = item.quantity;
              var uniteprice = (parseInt(item.price) / 100).toFixed(2);
              var cartImageUrl = getCartImageSizedUrl(item.image, '160x160');
              var cartImageAlt = escapeHtml(item.product_title || item.title || 'Cart item');
              ibm = parseInt(ibm) + 1;

              newcarttem += `
            <li class="cart__row cardrownow">
              <div data-comp="LineItem" class="css-ex3wou">
                <a data-comp="Link-Internal" tabindex="-1" href="${item.url}" class="css-uwcc3j">
                  <div data-comp="Picture" class="css-1ouq8i3">
                    <img class="cart__image" src="${cartImageUrl}" alt="${cartImageAlt}" width="80" height="80" loading="eager" decoding="async">
                  </div>
                </a>
                <div class="css-13uca9q">
                  <div class="css-cad606">
                    <div class="css-vah5x1">
                      <a data-comp="Link-Internal" href="${item.url}" class="css-uwcc3j">
                        <h5 class="css-fcsahh">${item.title}</h5>
                      </a>
                      <input type="hidden" class="productIDCart" value="${item.product_id}">
                      <ul class="product-details">
                        <li class="product-details__item product-details__item--variant-option">
                          ${item.options_with_values[0].name}: ${item.options_with_values[0].value}
                        </li>
                      </ul>
                    </div>
                    <a href="#" data-type="3" data-id="${item.id}" data-key="${ibm}" class="text-link text-link--accent removeproduct">
                      <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512">
                        <path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"/>
                      </svg>
                    </a>
                  </div>
                  <div class="css-zro5g6">
                    <div class="css-14sabt">
                      <div data-comp="Quantity" class="css-1fub689">
                        <button data-type="2" data-id="${item.id}" data-key="${ibm}" class="css-15fa4x3">
                          <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512">
                            <path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/>
                          </svg>
                        </button>
                        <div class="css-1ey6wd8">
                          <input type="number" min="0" max="151" name="quantity" tabindex="-1" class="css-1eg0jke" id="updates_${item.id}" value="${quantity}">
                        </div>
                        <button data-id="${item.id}" data-type="1" data-key="${ibm}" class="css-15fa4x3">
                          <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512">
                            <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"/>
                          </svg>
                        </button>
                      </div>
                      <div data-comp="Locale.CartLine" class="css-s7lvw9">
                        <div data-comp="Price" class="css-1y9e1aj">
                          <p class="css-1uy215x">$${uniteprice}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>`;

              checkIscompatibity(item.handle);
            });

            // Update cart content
            $('.css-bje8zw').html(newcarttem);
            $('.css-ssjggg').removeClass('hide');
            $('.css-16s26sc').removeClass('hide');
            $('.sidebar-product-wrap').removeClass('hide');
            $('.empty-page-content').addClass('hide');

            // Update shipping threshold and other UI elements
            var getTotal = parseInt(cart.items_subtotal_price);
            $('#totalVlye').val(getTotal);

            if (getTotal < freeShippingThreshold) {
              var remainAmount = ((freeShippingThreshold - getTotal) / 100).toFixed(2);
              $('.css-1encgqi').html(`You're only $${remainAmount} away from free shipping!`);
              var maxwidth = (parseInt(getTotal) * 100) / freeShippingThreshold;
              $('.css-nxglc6').css('max-width', maxwidth + '%');
            } else {
              $('.css-1encgqi').text("You're qualified for free shipping!");
              $('.css-nxglc6').css('max-width', '100%');
            }

            var subAmout = (parseInt(cart.total_price) / 100).toFixed(2);
            $('.css-9jq8tb').text(`$${subAmout} ${cart.currency}`);
          } else {
            // Empty cart state
            updateHeaderCartCount(0);
            $('.css-ssjggg, .css-16s26sc, .sidebar-product-wrap').addClass('hide');
            $('.empty-page-content').removeClass('hide');
            $('#totalVlye').val(0);
          }

          // Final updates
          updateCartDiscounts(cart);
          loadProductRecommendationsIntoSection();
          FreeShippingMeter();

          resolve(cart);
        })
        .catch(reject);
    });
  }

  function checkIscompatibity(checkProduct) {
    var dfmbc = checkProduct;
    checkProduct = checkProduct.replace(' ', '-');

    jQuery.getJSON('/products/' + checkProduct + '.js', function (product) {
      var yescomtive = '';
      var messagecont = 'Warning: ';
      var dfmn = '';

      let producttags = product.tags;

      producttags.forEach((item) => {
        if (item.indexOf('compatible') !== -1) {
          compatiblePlist.push(checkProduct);

          dfmn += 'The ' + dfmbc + ' ' + item.replace(':', ' with the ') + '.';

          $('.warning-message-check').show();

          // return item;
          // break;
        }
      });

      $('.warning-message-check .messge-warn').text(messagecont + dfmn);
      // Check if the product with a specific variant ID is in the cart
      var variantIdToCheck = '6574965293248';
      var lineItem = $('.productIDCart[value="' + variantIdToCheck + '"]').closest('[data-comp="LineItem"]');
      if (lineItem.length > 0) {
        lineItem.find('.css-uwcc3j').removeAttr('href').css('pointer-events', 'none');
        lineItem.find('.product-details').hide();
        lineItem.find('.css-15fa4x3').hide();
        lineItem.find('.css-1eg0jke').hide();
      }
    });
  }
  function checkTotalcompatible() {
    if (compatiblePlist.length == 0) {
      $('.warning-message-check').hide();
    }
  }

  } catch(e) { console.error(e); }
})();
})();
